<template>
  <v-dialog :value="sectionEditor.show" :width="1200" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <!-- Outer Section Colors -->
        <div>
          <label class="label-input">Section Content</label>
          <v-row>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="section-text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['section-text-color']"
                    @change="handleChangeSectionTextColor"
                  />
                  <v-text-field v-model="fields['section-text-color']" label="Text Color" />
                  <v-btn @click="handleResetSectionTextColor" small text color="primary">Reset</v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="section-background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['section-background-color']"
                    @change="handleChangeSectionBackgroundColor"
                  />
                  <v-text-field v-model="fields['section-background-color']" label="Background Color" />
                  <v-btn @click="handleResetSectionBackgroundColor" small text color="primary">Reset</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- Button Text Customization -->
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="fields['see-more-text']" label="See More Text" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="fields['see-less-text']" label="See Less Text" />
          </v-col>
        </v-row>

        <!-- Section Description -->
        <div>
          <label>Description</label>
          <ckeditor :editor="editor" v-model="fields['section-description']" :config="editorConfig" />
        </div>

        <!-- List Items Management -->
        <div>
          <div class="d-flex justify-space-between align-center mt-5">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label style="margin-bottom: 0" class="label-input">Grid Items</label>
            </div>
            <v-btn small text color="primary" @click="handleAddGridItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Grid Item</span>
            </v-btn>
          </div>
          <!-- Card Colors -->
          <v-row>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="card-text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-text-color']"
                    @change="handleChangeCardTextColor"
                  />
                  <v-text-field v-model="fields['card-text-color']" label="Card Text Color" />
                  <v-btn @click="handleResetCardTextColor" small text color="primary">Reset</v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="card-background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-background-color']"
                    @change="handleChangeCardBackgroundColor"
                  />
                  <v-text-field v-model="fields['card-background-color']" label="Card Background Color" />
                  <v-btn @click="handleResetCardBackgroundColor" small text color="primary">Reset</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields['grid-items']" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>{{ item.title || `Grid Item ${i + 1}` }}</span>
                  <v-btn icon @click.stop="handleRemoveGridItem(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="">
                  <div class="mb-5">
                    <label>Image</label>
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, i)"
                      :image="{ imageSrc: item.image }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUpload(i)"
                    />
                  </div>
                  <v-text-field outlined v-model="item.title" label="Title" type="text" />
                  <div class="mt-4">
                    <label class="label-input">Content</label>
                    <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

export default {
  name: 'collapsible-product-grid-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        'section-text-color': '#000000',
        'section-background-color': '#ffffff',
        'card-text-color': '#000000',
        'card-background-color': '#ffffff',
        'section-description': '',
        'see-more-text': 'see more',
        'see-less-text': 'see less',
        'grid-items': [],
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCollapsibleProductGrid(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },

    // Section Color Handlers
    handleChangeSectionTextColor(e) {
      this.fields['section-text-color'] = e.target.value;
    },
    handleResetSectionTextColor() {
      this.fields['section-text-color'] = '#000000';
    },
    handleChangeSectionBackgroundColor(e) {
      this.fields['section-background-color'] = e.target.value;
    },
    handleResetSectionBackgroundColor() {
      this.fields['section-background-color'] = '#ffffff';
    },

    // Card Color Handlers
    handleChangeCardTextColor(e) {
      this.fields['card-text-color'] = e.target.value;
    },
    handleResetCardTextColor() {
      this.fields['card-text-color'] = '#000000';
    },
    handleChangeCardBackgroundColor(e) {
      this.fields['card-background-color'] = e.target.value;
    },
    handleResetCardBackgroundColor() {
      this.fields['card-background-color'] = '#ffffff';
    },

    // Grid Item Handlers
    handleAddGridItem() {
      this.fields['grid-items'].push({
        image: '',
        title: '',
        content: '',
      });
    },
    handleRemoveGridItem(index) {
      this.fields['grid-items'].splice(index, 1);
    },
    handleUploadImage(obj, index) {
      this.fields['grid-items'][index].image = obj.imageSrc;
    },
    handleRemoveUpload(index) {
      this.fields['grid-items'][index].image = '';
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 200px;
}
.ck-editor__editable {
  min-height: 200px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
